import React, { Suspense, useEffect, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { Footer } from "../components/Footer/Footer";
import { Box } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import { Header } from "../components/Header/header";
import { MobileBar } from "../components/MobileBottomBar/mobile.bar";
import { MenuBar } from "../components/MenuBar/menu.bar";
import Registration from "../components/registration/Registration";
import Authorization from "../components/authorization/Authorization";
import ResetPassword from "../components/resetpassword/ResetPassword";
export const MainLayout = () => {
  const [menuOpened, setMenuOpened] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: "599.98px" });
  useEffect(() => {
    if (window.visualViewport) {
      const updateBottomBar = () => {
        const safeArea = window.outerHeight - window.innerHeight;
        document.documentElement.style.setProperty(
          "--safe-area-bottom",
          `${safeArea}px`
        );
        document.documentElement.style.setProperty(
          "--real-vh",
          `${window.innerHeight}px`
        );
        if (!isMobile) document.documentElement.style.overflow = "hidden";
        if (isMobile) document.documentElement.style.overflow = "unset";
      };
      window.visualViewport.addEventListener("resize", updateBottomBar);
      const safeArea =
        window.innerHeight -
        (window.visualViewport ? window.visualViewport.height : 0);
      document.documentElement.style.setProperty(
        "--safe-area-bottom",
        `${safeArea > 0 ? safeArea : 0}px`
      );
      document.documentElement.style.setProperty(
        "--real-vh",
        `${window.innerHeight}px`
      );
      if (!isMobile) document.documentElement.style.overflow = "hidden";
      if (isMobile) document.documentElement.style.overflow = "unset";
      return () =>
        window.visualViewport?.addEventListener("resize", updateBottomBar);
    }
  }, []);
  return (
    <>
      {isMobile ? (
        <Box
          sx={{
            height: "var(--real-vh)",
            width: "100vw",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box
            sx={{
              flex: "1 1 auto",
              height: "100%",
              width: "100%",
            }}
            className="root__container"
          >
            <Header />
            <Outlet />
            <Footer />
          </Box>
          <MobileBar menuOpened={menuOpened} setMenuOpened={setMenuOpened} />
          <MenuBar menuOpened={menuOpened} setMenuOpened={setMenuOpened} />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            width: "100vw",
            height: "var(--real-vh)",
            overflow: "hidden",
          }}
        >
          <MenuBar menuOpened={menuOpened} setMenuOpened={setMenuOpened} />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: menuOpened ? "calc(100% - 240px)" : "calc(100% - 78px)",
              height: "100%",
              overflowY: "auto",
              transition: "width 200ms cubic-bezier(0.14, -0.08, 0.74, 1.4)",
            }}
            className="root__container"
          >
            <Header />
            <Outlet />
            <Footer />
          </Box>
        </Box>
      )}
      <Suspense>
        <Registration />
        <Authorization />
        <ResetPassword />
      </Suspense>
    </>
  );
};
